<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">description</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onItemClick()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.numero"><strong [translate]="'admin.frais.fournisseurs.contrat.numero'"></strong> {{ data.numero }} </li>
            <li *ngIf="data.libelleImport"><strong [translate]="'admin.frais.fournisseurs.contrat.typeImport'"></strong> {{ data.libelleImport }} </li>
            <li><strong [translate]="'admin.frais.fournisseurs.contrat.typeContrat'"></strong> {{ getLibelleTypeContrat() }} </li>
            <li *ngIf="data.dateFin"><strong [translate]="'admin.frais.fournisseurs.contrat.dateFin'"></strong> {{ data.dateFin | date:'shortDate' }} </li>
        </ul>
    </div>
</div>